import React from 'react';
import ReactPaginate from 'react-paginate';

import * as S from './styles';

const Paginate = props => {
  const { isMobile, withBorders = true, ...otherProps } = props;
  const marginPagesDisplayed = isMobile ? 1 : 2;
  const pageRangeDisplayed = isMobile ? 1 : 5;

  return (
    <S.Wrapper>
      <ReactPaginate
        breakLabel="..."
        containerClassName="paginate"
        pageClassName="page"
        activeClassName="page-active"
        pageLinkClassName="page-link"
        activeLinkClassName="page-active-link"
        previousClassName="previous"
        nextClassName="next"
        breakClassName="break"
        breakLinkClassName="break-link"
        marginPagesDisplayed={marginPagesDisplayed}
        pageRangeDisplayed={pageRangeDisplayed}
        previousLabel={
          <S.ArrowButton withBorders={withBorders}>
            <S.Prev />
          </S.ArrowButton>
        }
        nextLabel={
          <S.ArrowButton withBorders={withBorders}>
            <S.Next />
          </S.ArrowButton>
        }
        {...otherProps}
      />
    </S.Wrapper>
  );
};

export default Paginate;
